import React from 'react';
import { BindAll } from 'lodash-decorators';
import { isEmpty } from 'lodash';
import { TextField, IconButton, InputAdornment } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import FilterListIcon from '@material-ui/icons/FilterList';
import './_PivotConfiguratorFilter.scss';

interface FilterProps {
  onChange: (value: string) => void;
}

interface FilterState {
  // leave this here so the text box changes immediately,
  // but we can debounce the filter computation itself
  value: string;
}

@BindAll()
class PivotConfiguratorFilter extends React.Component<FilterProps, FilterState> {
  public constructor(props: FilterProps) {
    super(props);

    this.state = {
      value: '',
    };
  }

  public handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const { onChange } = this.props;
    const value = event.target.value;

    if (onChange) {
      onChange(value);
    }
    this.setState({ value });
  }

  public handleClearFilter() {
    const { onChange } = this.props;
    const clear = '';

    if (onChange) {
      onChange(clear);
    }
    this.setState({ value: clear });
  }

  public render() {
    const { value } = this.state;
    const showClearIcon = !isEmpty(value);

    return (
      <div className="search-box">
        <div className="fuzzy-search">
          <span className="search-label">Filter Items</span>
          <TextField
            className="text-field"
            variant="outlined"
            size="small"
            fullWidth
            value={value}
            onChange={this.handleChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {showClearIcon && (
                    <IconButton size="small" onClick={this.handleClearFilter}>
                      <ClearIcon className="clear-icon" />
                    </IconButton>
                  )}
                  <FilterListIcon className="search-icon" />
                </InputAdornment>
              ),
            }}
          />
        </div>
      </div>
    );
  }
}

export default PivotConfiguratorFilter;
